import { Carousel, Image } from "react-bootstrap";
import {
  HeroSectionXL,
  HeroSectionL,
  HeroSectionM,
  HeroSectionS,
} from "src/assets";
import { useResponsiveBp } from "src/utils/hook-functions/responsive-bp.hook";

export const Section1 = () => {
  const { isMobile, isTablet, isDesktop, isLargeDesktop } = useResponsiveBp();

  const CarouselForm = (
    <Carousel controls={false} indicators={false}>
      <Carousel.Item>
        {isLargeDesktop && (
          <Image
            src={HeroSectionXL}
            alt="ItasgiveHeroXL"
            width="100%"
            height="100%"
          />
        )}

        {isDesktop && !isLargeDesktop && (
          <Image
            src={HeroSectionL}
            alt="ItasgiveHeroL"
            width="100%"
            height="100%"
          />
        )}

        {isTablet && !isDesktop && (
          <Image
            src={HeroSectionM}
            alt="ItasgiveHeroM"
            width="100%"
            height="100%"
          />
        )}

        {isMobile && (
          <Image
            src={HeroSectionS}
            alt="ItasgiveHeroS"
            width="100%"
            height="100%"
          />
        )}
      </Carousel.Item>
    </Carousel>
  );

  return <div>{CarouselForm}</div>;
};
